export default "__VITE_ASSET__CEuFa7x5__"